module.exports = __webpack_public_path__ + "img/Sudan.a5d21d02.gif";